import { z } from 'zod';
/**
 * Schema Zod para validar respuestas de endpoints de costos.
 * Cada endpoint usa el schema apropiado antes de devolver al frontend
 * y antes de parsear en el cliente.
 */
export const CostoSchema = z.object({
    entryNo: z.number().int(),
    fecha: z.string(),
    origen: z.enum(['PRODUCTION', 'SANDBOX']),
    worksNo: z.string(),
    proyectoDisplay: z.string().nullable(),
    taskNo: z.string().nullable(),
    tareaDisplay: z.string().nullable(),
    categoriaTarea: z.string().nullable(),
    llaveCodigo: z.string().nullable(),
    consolidatedCode: z.string().nullable(),
    description: z.string().nullable(),
    itemCategoryCode: z.string().nullable(),
    unidadMedida: z.string().nullable(),
    quantity: z.number(),
    unitCostLcy: z.number(),
    totalCostLcy: z.number(),
    lineAmountLcy: z.number(),
    esCostoDirecto: z.boolean(),
    tipoMovimiento: z.string().nullable(),
    documentNo: z.string().nullable(),
    externalDocNo: z.string().nullable(),
    vendorName: z.string().nullable(),
});
export const CostoMensualSchema = z.object({
    worksNo: z.string(),
    proyectoDisplay: z.string().nullable(),
    areaCosteo: z.string().nullable(),
    bloque: z.string(),
    subBloque: z.string().nullable(),
    anio: z.number().int(),
    mes: z.number().int().min(1).max(12),
    nombreMes: z.string(),
    totalCostoLcy: z.number(),
    totalQuantity: z.number(),
    rowCount: z.number().int(),
});
export const ResumenAreaCosteoSchema = z.object({
    areaCosteo: z.string(),
    bloque: z.string(),
    subBloque: z.string().nullable(),
    worksNo: z.string(),
    proyectoDisplay: z.string().nullable(),
    taskNo: z.string().nullable(),
    tareaDisplay: z.string().nullable(),
    tareaPadreDisplay: z.string().nullable(),
    itemCategoryCode: z.string(),
    descripcionItem: z.string().nullable(),
    anio: z.number().int(),
    mes: z.number().int().min(1).max(12),
    totalCostoLcy: z.number(),
    totalQuantity: z.number(),
});
export const CostoPorCategoriaSchema = z.object({
    itemCategoryCode: z.string(),
    totalCostoLcy: z.number(),
    rowCount: z.number().int(),
});
export const PresupuestoTareaSchema = z.object({
    worksNo: z.string(),
    taskNo: z.string(),
    presupuestoCosto: z.number(),
    presupuestoIndirecto: z.number(),
    presupuestoVenta: z.number(),
    /** Avance físico de la partida (fracción 0-1). Para Producción = avance × venta. */
    avancePct: z.number(),
});
/**
 * Wrapper genérico para respuestas paginadas.
 * Uso: const Schema = RespuestaPaginadaSchema(CostoSchema);
 */
export function respuestaPaginadaSchema(itemSchema) {
    return z.object({
        filas: z.array(itemSchema),
        pagina: z.number().int().positive(),
        tamanioPagina: z.number().int().positive(),
        totalFilas: z.number().int().nonnegative(),
        totalPaginas: z.number().int().nonnegative(),
    });
}
export const RespuestaCostosDetalladosSchema = respuestaPaginadaSchema(CostoSchema);
export const RespuestaCostosMensualesSchema = z.array(CostoMensualSchema);
export const RespuestaResumenAreaCosteoSchema = z.array(ResumenAreaCosteoSchema);
export const RespuestaCostosPorCategoriaSchema = z.array(CostoPorCategoriaSchema);
export const RespuestaPresupuestoTareasSchema = z.array(PresupuestoTareaSchema);
/** Fechas disponibles (YYYY-MM-DD) para el selector jerárquico de periodos. */
export const RespuestaPeriodosSchema = z.array(z.string());
/**
 * Períodos SEMANALES disponibles (anio, mes, semanaIso) con datos en las tablas
 * _semanal. Alimenta el selector Año › Mes › Semana ISO de Avance/Venta. Una
 * semana ISO que cruza meses aparece en ambos meses (grano partido por mes).
 */
export const PeriodoSemanalSchema = z.object({
    anio: z.number().int(),
    mes: z.number().int().min(1).max(12),
    semanaIso: z.number().int().min(1).max(53),
});
export const RespuestaPeriodosSemanalesSchema = z.array(PeriodoSemanalSchema);
/** Estados de venta disponibles para el filtro global (de fact_obra_estado_mensual). */
export const RespuestaEstadosVentaSchema = z.array(z.string());
//# sourceMappingURL=costo.schema.js.map